/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./src/assets/js/product-quick-add.js ***!
  \********************************************/
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('.product-card__quick-add-form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var productId = form.querySelector('input[name="id"]').value;
        var quantity = form.querySelector('input[name="quantity"]').value;
        var cartDrawer = document.querySelector('cart-drawer');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: productId,
            quantity: parseInt(quantity, 10)
          })
        }).then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              return Promise.reject(err);
            });
          }

          return response.json();
        }).then(function (data) {
          Toastify({
            text: "Product added to cart successfully",
            duration: 1500,
            className: "infoToast",
            close: false,
            gravity: "bottom",
            position: "center",
            stopOnFocus: true,
            style: {
              background: "#d54413"
            }
          }).showToast();
          document.querySelector('zapiet-widget').reloadCart();
        })["catch"](function (error) {
          Toastify({
            text: error.message || "Something went wrong",
            duration: 1000,
            close: false,
            className: "infoToast",
            gravity: "bottom",
            position: "center",
            stopOnFocus: true,
            style: {
              background: "#d54413"
            }
          }).showToast();
        });
      });
    });
  }, 500);
});
document.querySelectorAll('.add-to-cart-button button').forEach(function (button) {
  button.addEventListener('click', function () {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: button.getAttribute('data-variant-id'),
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          return Promise.reject(err);
        });
      }

      return response.json();
    }).then(function (data) {
      button.parentElement.style.display = 'none';
      button.closest('.product-smart-card__quick-add').querySelector('.quantity-selector').style.display = 'flex';
      button.closest('.product-smart-card__quick-add').querySelector('.quantity-selector input').value = 1;
      Toastify({
        text: "Added to cart successfully",
        duration: 1500,
        close: false,
        className: "infoToast",
        gravity: "bottom",
        position: "center",
        stopOnFocus: true,
        style: {
          background: "#d54413"
        }
      }).showToast();
      document.querySelector('zapiet-widget').reloadCart();
    })["catch"](function (error) {
      Toastify({
        text: error.message || "Something went wrong",
        duration: 1000,
        close: false,
        className: "infoToast",
        gravity: "bottom",
        position: "center",
        stopOnFocus: true,
        style: {
          background: "#d54413"
        }
      }).showToast();
    });
  });
});
document.querySelectorAll('.quantity-selector .increase-qty, .quantity-selector .decrease-qty').forEach(function (button) {
  button.addEventListener('click', function () {
    var input = button.parentElement.querySelector('input');
    var quantity = parseInt(input.value);

    if (button.classList.contains('increase-qty')) {
      quantity += 1;
    } else {
      quantity -= 1;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: button.getAttribute('data-variant-id'),
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          return Promise.reject(err);
        });
      }

      return response.json();
    }).then(function (data) {
      input.value = quantity;

      if (quantity === 0) {
        button.parentElement.style.display = 'none';
        button.closest('.product-smart-card__quick-add').querySelector('.add-to-cart-button').style.display = 'block';
      }

      Toastify({
        text: "Cart updated successfully",
        duration: 1000,
        close: false,
        className: "infoToast",
        gravity: "bottom",
        position: "center",
        stopOnFocus: true,
        style: {
          background: "#d54413"
        }
      }).showToast();
      document.querySelector('zapiet-widget').reloadCart();
    })["catch"](function (error) {
      Toastify({
        text: error.message || "Something went wrong",
        duration: 1000,
        close: false,
        className: "infoToast",
        gravity: "bottom",
        position: "center",
        stopOnFocus: true,
        style: {
          background: "linear-gradient(to right, #ff0000, #ff7a7a)"
        }
      }).showToast();
    });
  });
});
/******/ })()
;